/** Recording copy mirrored by MusicRecordingStrings on iOS. */
export const recordingStrings = {
  title: 'Recording', record: 'Record', stop: 'Stop recording', save: 'Save recording', remove: 'Delete recording',
  cancel: 'Cancel', discard: 'Discard recording', saving: 'Saving...', hint: 'A private recording, up to 1 minute.',
  deleteTitle: 'Delete this recording?', deleteBody: 'This recording will be permanently removed.',
  microphone: 'Allow microphone access to record a music moment.', unavailable: 'Recording is not supported in this browser. Try Safari or Chrome.',
};
